import { render, staticRenderFns } from "./chatFrame.vue?vue&type=template&id=8b1e2880&scoped=true"
import script from "./chatFrame.vue?vue&type=script&lang=js"
export * from "./chatFrame.vue?vue&type=script&lang=js"
import style0 from "./chatFrame.vue?vue&type=style&index=0&id=8b1e2880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1e2880",
  null
  
)

export default component.exports